import script from "./samples.vue?vue&type=script&setup=true&lang=ts"
export * from "./samples.vue?vue&type=script&setup=true&lang=ts"

import "./samples.vue?vue&type=style&index=0&id=7da443fa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7da443fa"]])

export default __exports__